import { render, staticRenderFns } from "./AIautoReplyConfig.vue?vue&type=template&id=6c45b881&scoped=true"
import script from "./AIautoReplyConfig.vue?vue&type=script&lang=js"
export * from "./AIautoReplyConfig.vue?vue&type=script&lang=js"
import style0 from "./AIautoReplyConfig.vue?vue&type=style&index=0&id=6c45b881&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c45b881",
  null
  
)

export default component.exports